var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "browser-support", staticStyle: { display: "none" } },
      [
        _c("span", { staticClass: "browser-support-text" }, [
          _vm._v("浏览器支持：")
        ]),
        _c("img", {
          attrs: { src: require("@/assets/img/chrome-icon.png"), alt: "Chrome" }
        }),
        _c("img", {
          attrs: {
            src: require("@/assets/img/firefox-icon.png"),
            alt: "Firefox"
          }
        }),
        _c("img", {
          attrs: { src: require("@/assets/img/ie-icon.png"), alt: "IE" }
        }),
        _c("img", {
          attrs: { src: require("@/assets/img/qq-icon.png"), alt: "QQ" }
        })
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }